(() => {
  const root = document.querySelector('.wt-product-gallery');
  if (!root || root.dataset.waterTankGalleryBound === 'true') return;
  root.dataset.waterTankGalleryBound = 'true';

  const activeHost = root.querySelector('.wt-gallery-active');
  const toolbar = root.querySelector('.pb-tools-1');
  const templates = new Map(
    Array.from(root.querySelectorAll('template.wt-gallery-template')).map((template) => [
      template.dataset.galleryKey,
      template,
    ]),
  );
  const whiteToolbarIndexes = String(root.dataset.whiteToolbarIndexes || '')
    .split(',')
    .map((value) => Number.parseInt(value.trim(), 10))
    .filter(Number.isFinite);

  let activeKey = null;
  let activeSwiper = null;
  let swiperWaitTimer = null;

  const setToolbarTone = (slideIndex) => {
    if (!toolbar) return;
    const useWhite = whiteToolbarIndexes.includes(Number(slideIndex));
    toolbar.classList.toggle('swiper-to-white', useWhite);
    toolbar.classList.toggle('swiper-to-black', !useWhite);
  };

  const stopMedia = () => {
    activeHost.querySelectorAll('video').forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.removeAttribute('src');
      video.load();
    });
  };

  const destroySwiper = () => {
    if (swiperWaitTimer) {
      window.clearTimeout(swiperWaitTimer);
      swiperWaitTimer = null;
    }
    if (activeSwiper && typeof activeSwiper.destroy === 'function') {
      activeSwiper.destroy(true, true);
    }
    activeSwiper = null;
  };

  const selectThumbnail = (container, index) => {
    container.querySelectorAll('.s-thumbnail-item').forEach((thumbnail) => {
      thumbnail.classList.toggle('selected', Number(thumbnail.dataset.slideIndex) === Number(index));
    });
  };

  const initSwiper = (container, attempt = 0) => {
    const swiperElement = container.querySelector('.mainSwiper');
    const slides = swiperElement?.querySelectorAll('.swiper-slide') || [];
    if (!swiperElement || slides.length === 0) return;

    if (!window.Swiper) {
      if (attempt >= 40) {
        console.error('[Water Tank Gallery] Swiper was not available after 4 seconds.');
        return;
      }
      swiperWaitTimer = window.setTimeout(() => initSwiper(container, attempt + 1), 100);
      return;
    }

    activeSwiper = new window.Swiper(swiperElement, {
      watchSlidesProgress: true,
      loop: false,
      slidesPerView: 1,
      initialSlide: 0,
      allowTouchMove: slides.length > 1,
      on: {
        init() {
          this.slideTo(0, 0, false);
          selectThumbnail(container, 0);
          setToolbarTone(0);
        },
        slideChange() {
          selectThumbnail(container, this.realIndex || 0);
          setToolbarTone(this.realIndex || 0);
        },
      },
    });

    container.querySelectorAll('.s-thumbnail-item').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!activeSwiper) return;
        const index = Number.parseInt(thumbnail.dataset.slideIndex, 10) || 0;
        activeSwiper.slideTo(index);
        selectThumbnail(container, index);
      });
    });
  };

  const renderGallery = (galleryKey, { force = false } = {}) => {
    if (!force && galleryKey === activeKey && activeHost.firstElementChild) return true;
    const template = templates.get(galleryKey);
    if (!template) {
      console.error(`[Water Tank Gallery] Missing gallery mapping for ${galleryKey}.`);
      return false;
    }

    stopMedia();
    destroySwiper();
    activeHost.replaceChildren();
    activeHost.appendChild(template.content.cloneNode(true));
    activeKey = galleryKey;
    root.dataset.activeGalleryKey = galleryKey;

    const rendered = activeHost.querySelector('.wt-gallery-rendered');
    if (!rendered) return false;
    selectThumbnail(rendered, 0);
    setToolbarTone(0);
    initSwiper(rendered);
    return true;
  };

  root.addEventListener('water-tank:gallery-change', (event) => {
    const galleryKey = event.detail?.galleryKey;
    if (galleryKey) renderGallery(galleryKey);
  });

  document.addEventListener('water-tank:variant-change', (event) => {
    const galleryKey = event.detail?.state?.galleryKey;
    if (galleryKey) renderGallery(galleryKey);
  });

  const logo = root.querySelector('.pbb-left[data-href]');
  if (logo) {
    logo.addEventListener('click', () => {
      window.location.assign(logo.dataset.href);
    });
    logo.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        window.location.assign(logo.dataset.href);
      }
    });
  }

  root.addEventListener('cartChange', async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const desktopCount = root.querySelector('.pr-text');
      const mobileCount = root.querySelector('.pr-label-inner');
      if (desktopCount) desktopCount.textContent = `Cart(${cart.item_count})`;
      if (mobileCount) mobileCount.textContent = String(cart.item_count);
    } catch (error) {
      console.error('[Water Tank Gallery] Unable to refresh cart count.', error);
    }
  });

  renderGallery(root.dataset.initialGalleryKey, { force: true });
})();
